import { Navigate } from 'react-router-dom';

export function Reporting() {
  return <Navigate to="/reports" replace />;
}
